var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"px-0 mx-0",attrs:{"fluid":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }